import { PromoProduct } from "@/core/entities/promotion";
import { TableColumnType } from "@ir/ui";
import {
  PromoProductUpcItemCell,
  PromoProductCategoryCell,
  PromoProductNameCell,
  PromoProductDiscountPercentageCell,
  PromoProductDiscountAmountCell,
} from "../components/PromotionProductsTableCells";
import { IPromoProductsColumns } from "@/core/repositories/promotion";

export interface PromotionProductsInScopeTableColumnOptions {
  columns: IPromoProductsColumns[];
  searchKeywords: string[];
  isRefreshing: boolean;
}


export const createProductsInScopeTableColumns = ({columns, searchKeywords, isRefreshing}: PromotionProductsInScopeTableColumnOptions): TableColumnType<PromoProduct>[] => {
  const currentTableColumns: TableColumnType<PromoProduct>[] = [
    {
      title: "UPC/Item No.",
      dataIndex: "product",
      key: "upcItemNumber",
      width: 100,
      verticalAlign: "top",
      cellRender(_value: unknown, record: PromoProduct) {
        return <PromoProductUpcItemCell promoProductUpcItemNumber={record?.product?.upcItemNumber} searchKeywords={searchKeywords} isRefreshing={isRefreshing}/>;
      },
    },
    {
      title: "Product Name",
      dataIndex: "product",
      key: "productName",
      width: 100,
      verticalAlign: "top",
      cellRender(_value: unknown, record: PromoProduct) {
        return <PromoProductNameCell promoProductName={record?.product?.productName} searchKeywords={searchKeywords} isRefreshing={isRefreshing}/>;
      },
    },
    {
      title: "Product Category",
      dataIndex: "product",
      key: "productCategory",
      width: 100,
      verticalAlign: "top",
      cellRender(_value: unknown, record: PromoProduct) {
        return (
          <PromoProductCategoryCell promoProductCategoryName={record?.product?.productCategory?.productCategoryName} isRefreshing={isRefreshing}/>
        );
      },
    },
    {
      title: "Discount Percentage",
      dataIndex: "discountPercentage",
      key: "productDiscountPercentage",
      width: 100,
      align: "right",
      verticalAlign: "top",
      cellRender(_value: unknown, record: PromoProduct) {
        return (
          <PromoProductDiscountPercentageCell promoProductDiscountPercentage={record?.discountPercentage} isRefreshing={isRefreshing}/>
        );
      },
    },
    {
      title: "Discount Amount",
      dataIndex: "discountAmount",
      key: "productDiscountAmount",
      width: 100,
      align: "right",
      verticalAlign: "top",
      cellRender(_value: unknown, record: PromoProduct) {

        return (
          <PromoProductDiscountAmountCell promoProductDiscountAmount={record?.discountAmount} isRefreshing={isRefreshing}/>
        );
      },
    },
  ];

  if (columns?.length === 0) {
    return currentTableColumns;
  }

  const tableColumns: TableColumnType<PromoProduct>[] = [];

  for (const column of columns) {
    const currentColumnProps = currentTableColumns.find(col => col.key === column.key);
    if (currentColumnProps) {
      tableColumns.push({
        ...currentColumnProps,
        title: column.title ?? currentColumnProps.title,
      });
    }
  }
  return tableColumns;
};
